import classNames from 'classnames';
import { IconAlertTriangle } from 'featherico';
import { useCallback, useState } from 'react';
import { useHeightAsCssVariable } from '../../hooks/useHeightAsCssVariable';
import { LicenseExpiredBanner } from '../LicenseExpiredWarnings';
import UserSessionWarnings from '../UserSessionWarnings';
import CompanyMessage from './CompanyMessage';
import HeaderSparks from './HeaderSparks';
import ImpersonationBanner from './ImpersonationBanner';
import TranslationPluginWarning from './TranslationPluginWarning';

const HeaderBroadcast = ({ className }: { className?: string }) => {
    const [node, setNode] = useState<HTMLElement | null>(null);
    const ref = useCallback((n: HTMLDivElement) => setNode(n), []);
    useHeightAsCssVariable('--headerBroadcastOffset', node);
    return (
        <div className={classNames(className, 'broadcastContainer')} ref={ref}>
            <div className="broadcast old-browser-warning">
                <div>
                    <strong>
                        <IconAlertTriangle /> We no longer support this browser.
                    </strong>{' '}
                    Some features may be unstable or unusable.{' '}
                    <a href="https://intercomdocs.small-improvements.com/en/articles/9146253-system-requirements">
                        Please use one of our supported browsers.
                    </a>
                </div>
            </div>
            <LicenseExpiredBanner />
            <UserSessionWarnings />
            <HeaderSparks />
            <ImpersonationBanner />
            <CompanyMessage />
            <TranslationPluginWarning />
        </div>
    );
};

export default HeaderBroadcast;
